import { VueFinalModalProperty } from "vue-final-modal";
import { InjectionKey } from "vue";

export const vfmInjectKey = Symbol() as InjectionKey<VueFinalModalProperty>;
